<template>
	<section>
		<!--工具条-->
		<el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
			<el-form :inline="true" :model="filters">
				<el-form-item>
					 <el-select v-model="filters.itemGroup" clearable placeholder="请选择项目分组" >
                        <el-option  v-for="(item,index) in options" :key="index" :label="item.item_group_name"  :value="item.item_group_code"> </el-option>
                     </el-select>
				</el-form-item>
				<el-form-item>
					<el-input v-model="filters.itemName" placeholder="项目名称"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" v-on:click="getItems">查询</el-button>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="handleAdd">新增</el-button>
				</el-form-item>
			</el-form>
		</el-col>

		<!--列表-->
		<el-table :data="items" border stripe highlight-current-row v-loading="listLoading" @selection-change="selsChange" @sort-change="sortChange" style="width: 100%;"
		:header-row-style="{backgroundColor:'#eef1f6',lineHeight:'20px',color:'#000'}" :row-style="{height:'30px'}">
			<el-table-column type="selection" width="55">
			</el-table-column>
			<el-table-column type="index" label="编号"  width="80">
			</el-table-column>
			<el-table-column prop="item_group_name" label="项目分组" width="120">
			</el-table-column>
			<el-table-column prop="item_name" label="项目名称" width="120" >
			</el-table-column>
			<el-table-column prop="item_value" label="项目值"width="120"  >
			</el-table-column>
			<el-table-column  prop="order_by" label="排序值" width="100" >		  
			</el-table-column>
			<el-table-column label="操作" >
				<template slot-scope="scope">
					<el-button size="small" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
					<el-button type="danger" size="small" @click="handleDel(scope.$index, scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!--工具条-->
		<el-col :span="24" class="toolbar">
			<el-col :span="8"> <el-button type="danger" @click="batchRemove" :disabled="this.sels.length===0">批量删除</el-button></el-col>
			<el-col :span="8">
				<el-pagination @size-change="handleSizeChange"  @current-change="handleCurrentChange" :current-page="currentPage"
							:page-sizes="[10, 20, 30, 40,50]" :page-size="pageSize"  layout="total, sizes, prev, pager, next, jumper" :total="total" style="float:left;">
				</el-pagination>
			</el-col>
		</el-col>

		<!--编辑界面-->
		<el-dialog title="编辑" :visible.sync="editFormVisible" :close-on-click-modal="false"  size="tiny">
			<el-form :model="editForm"   label-width="100px" :rules="editFormRules" ref="editForm">
				<el-form-item label="项目分组" prop="item_group">
					 <el-select v-model="editForm.item_group"  placeholder="请选择" >
                        <el-option  v-for="(item,index) in options" :key="index" :label="item.item_group_name"  :value="item.item_group_code"> </el-option>
                     </el-select>
				</el-form-item>
				<el-form-item label="项目名称" prop="item_name">
				     <el-input v-model="editForm.item_name" auto-complete="off" ></el-input>
				</el-form-item>
				<el-form-item label="项目值" prop="item_value">
					 <el-input v-model="editForm.item_value" auto-complete="off" ></el-input>
				</el-form-item>			
				<el-form-item label="排序值" prop="order_by">					
					 <el-input v-model.number="editForm.order_by" auto-complete="off" ></el-input>
				</el-form-item>			
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click.native="editFormVisible = false">取消</el-button>
				<el-button type="primary" @click.native="editSubmit" :loading="editLoading">提交</el-button>
			</div>
		</el-dialog>
	</section>
</template>

<script>
	//import util from '../../common/js/util'

	import { getItemListPage,addItem,editItem, removeItem,batchRemoveItem,getItemGroup } from '../../api/api';

 let CurrentUserID="",Session=""; 
	export default {
		data() {
			return {
				filters: {
					itemName: '',
					itemGroup:''

				},
				options: [],
				items: [],
				total: 0,
				pageSize:10,
				currentPage: 1,
				listLoading: false,
				sels: [],//列表选中列
                 prop:"", 
				 order:"",
				editFormVisible: false,//编辑界面是否显示
				editLoading: false,
				editFormRules: {
					item_name: [
						{ required: true, message: '请输入项目名称', trigger: 'blur' }
					],
					item_value: [
						{ required: true, message: '请输入项目值', trigger: 'blur' }
					],
					item_group: [
						{ required: true, message: '请选择项目分组', trigger: 'blur' }
					],
					order_by:[
						
                        { type: 'number', message: '排序值必须为数字', trigger: 'blur'}
					]
				},
				//编辑界面数据
				editForm: {
					id: 0,
					item_group: '',
					item_name: '',
					item_value:'',
					order_by: 0
				},

				formStatus: 0   //界面状态 0新增 1修改 2查看

			}
		},
		methods: {
			 handleSizeChange(val) {
				this.pageSize=val;                 
				this.getItems();
             },		
			handleCurrentChange(val) {
				this.currentPage = val;
				this.getItems();
			
			},
			//获取用户列表
			getItems() {
				let para = {
				    CurrentUserID:CurrentUserID,
					currentPage: this.currentPage,
					pageSize:this.pageSize,
					itemName:this.filters.itemName,
					itemGroup:this.filters.itemGroup,
					sortName:this.prop,
					sortOrder:this.order,
					Session:Session
				};
				this.listLoading = true;
				

            this.$http.jsonp(getItemListPage, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							 this.total = res.data.itemlist.total;
					         this.items = res.data.itemlist.items;
					         this.listLoading = false;
                           
                         }
                         else{   
							  this.listLoading = false;
                              if (res.data.result_code==911)
							  {

                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
								this.$message({
									message:'接口错误',
									type: 'error'
								});

							  }

                             
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'访问接口失败',
                                type: 'error'
                              });
                       this.listLoading = false;
                   }
           )






			},
			//删除
			handleDel: function (index, row) {
				this.$confirm('确认删除该记录吗?', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { CurrentUserID:CurrentUserID,id: row.id,Session:Session};


                   this.$http.jsonp(removeItem, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getItems();
                           
                         }
                         else{  

							 this.listLoading = false;
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有权限删除',
                                type: 'error'
                              });
							}

                            
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'访问接口失败',
                                type: 'error'
                              });
                     this.listLoading = false;
                   });


				}
				
				).catch(() => {

				});
			},
			//显示编辑界面
			handleEdit: function (index, row) {
	
				this.formStatus=1;
				this.editFormVisible = true;
			    this.editForm = {
					id: 0,
					item_group: '',
					item_name: '',
					item_value:'',
					order_by: 0
				};
				
				this.editForm = Object.assign({}, row);            
			  
				//this.$refs['editForm'].resetFields();
				
			},
			//显示新增界面
			handleAdd: function () {
				
				this.formStatus=0;
				this.editFormVisible = true;
				
				this.editForm = {
					id: 0,
					item_group: '',
					item_name: '',
					item_value:'',
					order_by: 0
				};
               if (this.$refs['editForm'] !== undefined) {						
                    this.$refs['editForm'].resetFields();
                }
				
			},
			//编辑
			editSubmit: function () {
				this.$refs.editForm.validate((valid) => {
					if (valid) {
						this.$confirm('确认提交吗？', '提示', {}).then(() => {
							this.editLoading = true;
							//NProgress.start();
							let para = Object.assign({}, this.editForm);
							para["CurrentUserID"] = CurrentUserID;
							para["Session"]=Session;

			   let itemUrl=	addItem;			  
               if (this.formStatus==1)
			   {
                  itemUrl=editItem;
			   }
                this.$http.jsonp(itemUrl, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							    
							   		this.editForm = {
										id: 0,
										item_group: '',
										item_name: '',
										item_value:'',
										order_by: 0
									};
							    if (this.$refs['editForm'] !== undefined) {						
									this.$refs['editForm'].resetFields();
								}
							 	this.editLoading = false;								
								this.$message({
									message: '提交成功',
									type: 'success'
								});
								

								if (this.formStatus==1)
								{
								  this.editFormVisible = false;
								}
								this.getItems();
                           
                         }
                         else{                           
                            
							 this.editLoading = false;
							 if (res.data.result_code==911)
							  {
                                 this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==912)
                            {
                              this.$message({
                                message:'没有新增权限',
                                type: 'error'
                              });
							   return;
							}
							if  (res.data.result_code==913)
                            {
                              this.$message({
                                message:'没有编辑权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'错误',
                                type: 'error'
                              });
                      this.editLoading = false;	
                   }
           )

						});
					}
				});
			},
			
			selsChange: function (sels) {
				this.sels = sels;
			},
			sortChange:function(order){
                   this.prop=order.prop;
				   this.order=order.order,
                 this.getItems();
			},
			//批量删除
			batchRemove: function () {
				var ids = this.sels.map(item => item.id).toString();
				this.$confirm('确认删除选中记录吗？', '提示', {
					type: 'warning'
				}).then(() => {
					this.listLoading = true;
					//NProgress.start();
					let para = { ids: ids,CurrentUserID:CurrentUserID,Session:Session };


                   this.$http.jsonp(batchRemoveItem, {params: para}).then(
                   function(res){                         
                         if (res.data.result_code==200)
                         {
							this.listLoading = false;
							this.$message({
							message: '删除成功',
							type: 'success'
						    });
							this.getItems();
                           
                         }
                         else{                           
                                this.listLoading = false;
							if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'接口错误',
										type: 'error'
									});
                                  return;
							  }
							if  (res.data.result_code==914)
                            {
                              this.$message({
                                message:'没有删除权限',
                                type: 'error'
                              });
							   return;
							}
                         }
                       

                   },
                   function(res)
                   {
                        this.$message({
                                message:'接口访问失败',
                                type: 'error'
                              });
                      this.listLoading = false;
                   });


				}).catch(() => {

				});
			}
		},
		mounted() {
			CurrentUserID=sessionStorage.getItem('userID')==null?0:sessionStorage.getItem('userID'); 
            Session=sessionStorage.getItem('session')==null?0:sessionStorage.getItem('session'); 
			this.$http.jsonp(getItemGroup,{params: {CurrentUserID:CurrentUserID,Session:Session}}).then(
			function(res){                         
					if (res.data.result_code==200)
					{						
						this.options=res.data.groups;					
					}
					else{                           
						this.$message({
						message:'获取项目分组错误',
						type: 'error'
						});

						if (res.data.result_code==911)
							  {
                                  this.$router.push({ path: "/login"});
								  return;
							  }

                              if (res.data.result_code==600)
							  {
									this.$message({
										message:'获取项目分组错误',
										type: 'error'
									});
                                  return;
							  }

					
					}
				

			},
			function(res)
			{
				this.$message({
						message:'获取项目分组错误',
						type: 'error'
						});
				
			});

			this.getItems();


		}
	}

</script>

<style scoped>
  .el_input_width{
	 width:220px; 
  }
</style>


// WEBPACK FOOTER //
// dictionary.vue?6878622e